import { ASSET_W } from './constants';
import { createDefaultWorldModels } from './components/world-model';
import { geodeLayoutFromModel } from './components/geode/geode-model';

/** Percent anchors — play-panel geode at ~76% x / 70% y of the 2800×2400 stage. */
export function geodeCenter() {
  const { geode } = createDefaultWorldModels();
  return { x: geode.cx, y: geode.cy };
}

export function geodeLayout() {
  return geodeLayoutFromModel(createDefaultWorldModels().geode);
}

/** World Boogatooth by the town door (main game defaults). */
export function tigerLayout() {
  return createDefaultWorldModels().boogas.tiger;
}

/** Matches #player-character-container in the main game viewport. */
export function playerLayout() {
  return createDefaultWorldModels().boogas.player;
}

export function scrollForPanel(panel: 0 | 1) {
  return panel === 0 ? 0 : ASSET_W / 2;
}
